export const autoria = {
  meusCursos: {
    title: 'Meus Cursos',
    description: 'Crie e gerencie os cursos dos quais você é autor.',
    novoCurso: 'Novo curso',
    empty: 'Você ainda não criou cursos.',
    emptyDescription: 'Crie seu primeiro curso para montar módulos, aulas e quizzes.',
    abrir: 'Abrir editor',
    acoes: 'Ações',
    excluirTitle: 'Remover curso?',
    excluirDescription: 'Esta ação não pode ser desfeita.',
  },
  novoCurso: {
    title: 'Novo curso',
    titulo: 'Título',
    tituloPlaceholder: 'Ex.: Clean Architecture na prática',
    descricao: 'Descrição',
    descricaoPlaceholder: 'Resumo do que o curso cobre (opcional)',
    emiteCert: 'Emite certificado',
    emiteCertHint: 'Esta opção congela após a primeira publicação.',
    criar: 'Criar curso',
  },
  editor: {
    voltar: 'Meus Cursos',
    metadados: 'Metadados do curso',
    estrutura: 'Estrutura',
    semModulos: 'Nenhum módulo ainda.',
    semAulas: 'Sem aulas',
    novoModulo: 'Novo módulo',
    novaAula: 'Nova aula',
    selecioneAula: 'Selecione uma aula para editar seu conteúdo.',
    emiteCertCongelado: 'Congelado após a publicação.',
    moverAcima: 'Mover para cima',
    moverAbaixo: 'Mover para baixo',
    renomear: 'Renomear',
    acoes: 'Ações',
  },
  modulo: {
    novoTitulo: 'Título do módulo',
    excluirTitle: 'Excluir módulo?',
    excluirDescription: 'Isso remove o módulo e todas as suas aulas. Não pode ser desfeito.',
  },
  aula: {
    novoTitulo: 'Título da aula',
    tipo: 'Tipo',
    opcional: 'Opcional (não conta na conclusão)',
    kind: {
      text: 'Texto',
      video: 'Vídeo',
      quiz: 'Quiz',
    },
    excluirTitle: 'Excluir aula?',
    excluirDescription: 'A aula e seu conteúdo serão removidos. Não pode ser desfeito.',
  },
  aulaEditor: {
    title: 'Editar aula',
    titulo: 'Título',
    conteudo: 'Conteúdo da aula',
    video: {
      provider: 'Provedor',
      externalRef: 'ID do vídeo',
      externalRefHint: 'Identificador do vídeo no provedor (ex.: dQw4w9WgXcQ).',
      preview: 'Pré-visualização',
      semPreview: 'Informe o provedor e o ID do vídeo para ver a pré-visualização.',
    },
    quiz: {
      intro: 'Edite o banco de questões e os parâmetros deste quiz.',
    },
  },
  quiz: {
    title: 'Editor de quiz',
    naoConfigurado: 'Quiz ainda não configurado',
    naoConfiguradoHint: 'Crie o quiz para definir os parâmetros e adicionar questões.',
    configurar: 'Configurar quiz',
    parametros: 'Parâmetros',
    notaMinima: 'Nota mínima de aprovação (%)',
    tentativas: 'Tentativas',
    ilimitadas: 'Ilimitadas',
    maximo: 'Máximo',
    salvarParametros: 'Salvar parâmetros',
    banco: 'Banco de questões',
    novaQuestao: 'Nova questão',
    semQuestoes: 'Nenhuma questão ainda.',
    semQuestoesHint: 'Adicione ao menos 1 questão para publicar esta aula de quiz.',
    enunciado: 'Enunciado',
    enunciadoPlaceholder: 'Digite o enunciado da questão',
    tipoSingle: 'Múltipla escolha',
    tipoTf: 'Verdadeiro / Falso',
    opcao: 'Opção',
    opcaoPlaceholder: 'Texto da opção',
    addOpcao: 'Adicionar opção',
    correta: 'Correta',
    verdadeiro: 'Verdadeiro',
    falso: 'Falso',
    correctIsTrue: 'Resposta correta',
    salvarQuestao: 'Salvar questão',
    excluirQuestaoTitle: 'Remover questão?',
    excluirQuestaoDescription: 'A questão e suas opções serão removidas. Não pode ser desfeito.',
    erroSingleUmaCorreta: 'Múltipla escolha exige exatamente uma opção correta.',
    erroSingleMinOpcoes: 'Múltipla escolha exige no mínimo duas opções.',
    erroEnunciadoVazio: 'O enunciado não pode ficar vazio.',
    erroOpcaoVazia: 'O texto das opções não pode ficar vazio.',
  },
  videoAula: {
    origem: 'Origem do vídeo',
    origemArquivo: 'Enviar arquivo',
    origemLink: 'Link do YouTube/Vimeo',
    aguardando: 'Aguardando vídeo',
    novaAulaDica:
      'A aula nasce aguardando vídeo e fica em breve até você enviar o vídeo e liberar.',
    soltarArquivo: 'Arraste o vídeo MP4 para cá ou clique para escolher',
    soltarDescricao: 'Arquivo MP4 de até 1 GB.',
    escolherArquivo: 'Escolher arquivo',
    enviando: 'Enviando: {{percent}}%',
    confirmando: 'Conferindo o arquivo...',
    pausado: 'Envio pausado em {{percent}}%.',
    cancelar: 'Cancelar envio',
    retomar: 'Retomar envio',
    descartar: 'Escolher outro arquivo',
    trocar: 'Trocar vídeo',
    remover: 'Remover vídeo',
    removerTitulo: 'Remover o vídeo?',
    removerDescricao: 'O arquivo é apagado e a aula volta para em breve até receber outro vídeo.',
    atual: 'Vídeo atual: {{nome}} ({{tamanho}})',
    enviado: 'Vídeo enviado.',
    removido: 'Vídeo removido.',
    salvarLink: 'Salvar link',
    trocarParaLinkTitulo: 'Trocar o arquivo pelo link?',
    trocarParaLinkDescricao: 'O vídeo enviado e a legenda serão apagados.',
    legenda: 'Legenda (.vtt)',
    legendaDica: 'Opcional. Arquivo WebVTT em UTF-8, de até 512 KB.',
    legendaSemVideo: 'Envie o vídeo antes da legenda.',
    legendaEnviar: 'Enviar legenda',
    legendaTrocar: 'Trocar legenda',
    legendaRemover: 'Remover legenda',
    legendaAtual: 'Legenda enviada.',
    legendaEnviada: 'Legenda salva.',
    legendaRemovida: 'Legenda removida.',
    previa: 'Prévia',
    previaIndisponivel: 'A prévia aparece depois que o vídeo for enviado.',
    playerRotulo: 'Vídeo da aula',
    legendaPt: 'Português (Brasil)',
    playerFalhou: 'Não foi possível carregar o vídeo.',
    tentarDeNovo: 'Tentar de novo',
    erros: {
      formato: 'Envie um arquivo MP4.',
      tamanho: 'O vídeo passa do tamanho máximo de 1 GB.',
      rede: 'A conexão caiu durante o envio. Use “Retomar envio” para continuar de onde parou.',
      expirado: 'O link de envio venceu. Use “Retomar envio” para continuar.',
      incompleto: 'O arquivo chegou incompleto. Envie de novo.',
      indisponivel: 'O envio de vídeos ainda não está disponível neste ambiente.',
      cancelado: 'Envio cancelado.',
      legenda: 'A legenda precisa ser um arquivo .vtt em UTF-8, de até 512 KB.',
      generico: 'Não foi possível enviar o vídeo. Tente de novo.',
    },
  },
  liberacao: {
    rotulo: 'Disponibilidade para alunos',
    liberada: 'Liberada',
    emBreve: 'Em breve',
    precisaVideo: 'Envie o vídeo ou informe um link antes de liberar esta aula.',
    alterada: 'Disponibilidade atualizada.',
    avisoCurso_one: '{{count}} aula está em breve e ainda não abre para os alunos.',
    avisoCurso_other: '{{count}} aulas estão em breve e ainda não abrem para os alunos.',
  },
  toast: {
    cursoCriado: 'Curso criado.',
    cursoAtualizado: 'Curso atualizado.',
    cursoExcluido: 'Curso removido.',
    cursoPublicado: 'Curso publicado.',
    cursoArquivado: 'Curso arquivado.',
    moduloCriado: 'Módulo criado.',
    moduloAtualizado: 'Módulo atualizado.',
    moduloExcluido: 'Módulo removido.',
    aulaCriada: 'Aula criada.',
    aulaAtualizada: 'Aula salva.',
    aulaExcluida: 'Aula removida.',
    ordemAtualizada: 'Ordem atualizada.',
    quizCriado: 'Quiz criado.',
    parametrosSalvos: 'Parâmetros salvos.',
    questaoAdicionada: 'Questão adicionada.',
    questaoAtualizada: 'Questão atualizada.',
    questaoRemovida: 'Questão removida.',
  },
  erros: {
    cursoEmUso:
      'Não foi possível remover: há matrículas ou uso em trilha. Arquive em vez de remover.',
    emiteCertCongelado: 'O certificado já foi congelado na publicação e não pode ser alterado.',
    kindNaoQuiz: 'Esta aula não é um quiz.',
  },
} as const;
